import { AIMatchKey, AIMatchSettingsType, Setting } from 'components/types';
import dayjs from 'dayjs';

export const getTimeSlotOptions = (
  startTime?: Date | string,
  endTime?: Date | string
) => {
  const start = dayjs(
    startTime || dayjs().set('hour', 7).set('minutes', 30),
    'HH:mm'
  );
  const end = dayjs(endTime || start.add(24, 'hours'), 'HH:mm');
  const diff = end.diff(start, 'hours');

  let currentTime = start.clone();

  return Array.from({ length: diff * 2 }, () => {
    currentTime = currentTime.add(30, 'minutes');
    const value = currentTime.format('HH:mm');

    return {
      value,
      label: value
    };
  });
};

export const getValuesByAIMatchSettingsType = (
  type: AIMatchSettingsType,
  settings: Setting[]
) => {
  return settings.find((setting) => setting.key === `${AIMatchKey}.${type}`);
};
